/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const EmailKeyIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Email Key',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M11.165 17.938 0 9.511v16.684l11.165-8.257zM35.445 35.533v-2.887h-3.763v-1.084h3.763v-2.237a.467.467 0 0 0-.467-.467h-3.3v-5.927a5.546 5.546 0 0 0 2.283-1.359 5.607 5.607 0 1 0-7.93 0 5.542 5.542 0 0 0 2.313 1.367v12.126a.935.935 0 0 0 .935.935h5.695a.467.467 0 0 0 .471-.467Zm-4.123-17.462a1.869 1.869 0 1 1 0-2.643 1.869 1.869 0 0 1 0 2.643Z"
    />
    <path
      d="m22.178 19.921-2.888 2.173a2.171 2.171 0 0 1-2.58 0l-3.628-2.719L0 29.068v1.765A1.147 1.147 0 0 0 1.125 32h24.822v-7.3a8.153 8.153 0 0 1-3.769-4.779Z"
    />
    <path
      d="M30 9.423a8.135 8.135 0 0 1 1.974.267L36 6.665v-1.5A1.147 1.147 0 0 0 34.875 4H1.125A1.147 1.147 0 0 0 0 5.167v1.468l18 13.553 3.839-2.888A8.176 8.176 0 0 1 30 9.423Z"
    />
  </svg>`;
};
